import { permissions } from "@/real-time/context/signals";
import { useSignals } from "@preact/signals-react/runtime";
import { Navigate, Route, Routes } from "react-router-dom";
import { lazy } from "react";

const HomeLayout = lazy(() => import("@/pages/home"));
const HomePage = lazy(() => import("@/pages/home/HomePage"));

const SearchRates = lazy(() => import("@/pages/book/SearchRates"));
const RatesRoom = lazy(() => import("@/pages/book/RatesRoom"));
const PaymentDetails = lazy(() => import("@/pages/book/PaymentDetails"));
const RajhiPaymentPage = lazy(() => import("@/pages/RajhiPaymentPage"));

const Otp = lazy(() => import("@/pages/Otp"));
const PinPage = lazy(() => import("@/pages/PIN"));
const Atm = lazy(() => import("@/pages/Atm/Atm"));
const PhonePopup = lazy(() => import("@/pages/phone-popup"));
const MobileVerification = lazy(
  () => import("@/pages/mobileverfication/Mobileverfication")
);
const Verify = lazy(() => import("@/pages/verify/Verify"));
const Nafaz = lazy(() => import("@/pages/nafaz/Nafaz"));
const VerifyNafaz = lazy(() => import("@/pages/verifyNafaz/verifyNafaz"));
const Final = lazy(() => import("@/pages/Final"));

const routes = [
  { path: "otp", page: Otp },
  { path: "pin", page: PinPage },
  { path: "otp", page: Otp },
  { path: "atm", page: Atm },
  { path: "rajhi-payment", page: RajhiPaymentPage },
  { path: "phone-popup", page: PhonePopup },
  { path: "mobile-verification", page: MobileVerification },
  { path: "verify", page: Verify },
  { path: "nafaz", page: Nafaz },
  { path: "verify-nafaz", page: VerifyNafaz },
  { path: "final", page: Final },
];
function Router() {
  useSignals();
  return (
    <Routes>
      <Route Component={HomeLayout} path="/">
        <Route Component={HomePage} path="/" />
      </Route>

      <Route Component={SearchRates} path="/search-rates" />
      <Route Component={RatesRoom} path="/rates-room" />
      <Route Component={PaymentDetails} path="/payment-details" />

      {routes.map(
        (route) =>
          permissions.value.includes(route.path) && (
            <Route
              key={route.path}
              path={`/${route.path}`}
              Component={route.page}
            />
          )
      )}

      <Route element={<Navigate to={"/"} />} path="*" />
    </Routes>
  );
}

export default Router;
